import { ConfigProvider, TimePicker } from 'antd';
import type { CSSProperties } from 'react';
import {
    PICKER_CLASS_NAME,
    pickerPopupProps,
    toTimeValue,
    useDateTimePicker,
} from './pickerShared';

export interface AppTimePickerProps {
    value?: string;
    defaultValue?: string;
    onChange: (time: string) => void;
    disabled?: boolean;
    allowClear?: boolean;
    id?: string;
    size?: 'small' | 'middle';
    onOpenChange?: (open: boolean) => void;
    style?: CSSProperties;
    className?: string;
}

const AppTimePicker = ({
    value,
    defaultValue,
    onChange,
    disabled = false,
    allowClear = false,
    id,
    size = 'middle',
    onOpenChange,
    style,
    className,
}: AppTimePickerProps) => {
    const { locale, theme } = useDateTimePicker();
    const valueProps = value !== undefined
        ? { value: toTimeValue(value) }
        : { defaultValue: toTimeValue(defaultValue || '') };

    return (
        <ConfigProvider locale={locale} theme={theme}>
            <TimePicker
                {...pickerPopupProps}
                {...valueProps}
                id={id}
                size={size}
                className={[PICKER_CLASS_NAME, className].filter(Boolean).join(' ')}
                format="HH:mm"
                disabled={disabled}
                allowClear={allowClear}
                inputReadOnly={false}
                onChange={(time) => onChange(time?.format('HH:mm') ?? '')}
                onOpenChange={onOpenChange}
                style={{ width: '100%', ...style }}
            />
        </ConfigProvider>
    );
};

export default AppTimePicker;
